import { render } from "./StockChartView.vue?vue&type=template&id=1446affe&ts=true"
import script from "./StockChartView.vue?vue&type=script&lang=ts"
export * from "./StockChartView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__